import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  banCard: () => ({
    url: 'crm/api/v1/Operation/CardBan',
    method: 'GET',
  }),
  forgetCardPassword: () => ({
    url: 'crm/api/v1/Operation/CardForgetPassword',
    method: 'GET',
  }),
  duplicateCard: () => ({
    url: 'crm/api/v1/Operation/CardDuplicate',
    method: 'GET',
  }),
  getUserContracts: () => ({
    url: 'crm/api/v1/User/Me',
    method: 'GET',
  }),
  getContract: ({ code }) => ({
    url: `crm/api/v1/Contract/Get/${code}`,
    method: 'GET',
  }),
  sendContractOtp: (input) => ({
    url: 'crm/api/v1/Contract/Submit',
    method: 'POST',
    data: input,
  }),
  verifyContractOtp: (input) => ({
    url: 'crm/api/v1/Contract/Verify',
    method: 'POST',
    data: input,
  }),
  getDuplicationReasons: () => ({
    url: 'crm/api/v1/Operation/CardDuplicationRequestReason',
    method: 'GET',
  }),
  duplicateCardV2: (input) => ({
    url: 'crm/api/v2/Operation/CardDuplicate',
    method: 'POST',
    data: input,
  }),
};

export default apis;
